import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products
export const getProducts = async (params = {}) => {
  const response = await api.get('/products', { params });
  return response.data;
};

export const getProduct = async (id) => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

export const createProduct = async (product, adminKey) => {
  const response = await api.post('/admin/products', product, {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

export const updateProduct = async (id, product, adminKey) => {
  const response = await api.put(`/admin/products/${id}`, product, {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

export const deleteProduct = async (id, adminKey) => {
  const response = await api.delete(`/admin/products/${id}`, {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

// Checkout
export const createCheckoutSession = async (cartItems, originUrl, promoCode = null, email = null) => {
  const response = await api.post('/checkout/session', {
    cart_items: cartItems.map(item => ({
      product_id: item.product.id,
      quantity: item.quantity,
    })),
    origin_url: originUrl,
    promo_code: promoCode || null,
    email: email || null,
  });
  return response.data;
};

export const validatePromoCode = async (code, subtotal) => {
  const response = await api.post('/promo/validate', { code, subtotal });
  return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const response = await api.get(`/checkout/status/${sessionId}`);
  return response.data;
};

// Newsletter
export const subscribeNewsletter = async (email) => {
  const response = await api.post('/newsletter/subscribe', { email });
  return response.data;
};

export const getSubscribers = async (adminKey) => {
  const response = await api.get('/admin/newsletter/subscribers', {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

// Chat
export const sendChatMessage = async (name, email, message) => {
  const response = await api.post('/chat/message', { name, email, message });
  return response.data;
};

export const getChatMessages = async (adminKey) => {
  const response = await api.get('/admin/chat/messages', {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

export const markMessageRead = async (messageId, adminKey) => {
  const response = await api.put(`/admin/chat/messages/${messageId}/read`, {}, {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

// Admin
export const getTransactions = async (adminKey) => {
  const response = await api.get('/admin/transactions', {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

export const verifyAdminKey = async (adminKey) => {
  const response = await api.post('/admin/verify', {}, {
    headers: { 'X-Admin-Key': adminKey },
  });
  return response.data;
};

// Seed data
export const seedProducts = async () => {
  const response = await api.post('/seed');
  return response.data;
};

export default api;
